<template>
  <card-block>
    <card-header>
      Тарифы подписки
      <template v-slot:right>
        <router-link :to="{name: 'subscription-tariff.create'}" v-if="can('module.subscription_tariff.create')">
          Добавить тариф
        </router-link>
      </template>
    </card-header>
    <card-body>
      <spinner-block v-model="progress">
        <div class="mb-3 row">
          <div class="col-12 col-md-3">

            <div class="small">Тип</div>
            <gui-select sm v-model="filter.active" @change="getList" :hilightOn="['all']">
              <option value="all">Все</option>
              <option value="active">Активные</option>
              <option value="deactive">Неактивные</option>
            </gui-select>
          </div>
          <div class="col-12 col-md-4">
          </div>
          <div class="col-12 col-md-5">
            <div class="small">Поиск</div>
            <gui-search sm v-model="filter.search" @change="getList" :hilightOn="['', undefined]"/>
          </div>
        </div>
        <div v-if="data && data.data && data.data.length">
          <table class="table table-hover">
            <thead>
            <tr>
              <th class="pr-0" style="width: 1rem;"></th>
              <th>Название</th>
              <th>Стоимость</th>
              <th>Длительность, месяцев</th>
              <th>Кол-во бесплатных вызовов</th>
              <th>Дата деактивации</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="row in data.data" :key="row.id">
              <th class="pr-0">
                <i class="fas fa-circle small"
                   :title="row.is_active ? 'Активен' : 'Неактивен'"
                   :class="row.is_active ? 'text-success' : 'text-danger'"></i>
              </th>
              <td class="limit-third_length">
                <router-link :to="{name: 'subscription-tariff.detail', params: {id: row.id}}" class="main-link">
                  #{{ row.id }} {{ row.name ? row.name : '—' }}
                </router-link>
              </td>
              <td>
                {{ row.cost }}
              </td>
              <td>
                {{ row.time }}
              </td>
              <td>
                {{ row.free_calls_count }}
              </td>
              <td>
                {{ toTime(row.deactivated_at) }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div v-else class="alert alert-info">Список пуст</div>
      </spinner-block>
      <gui-paginate :data="data" ref="paginate" @change="getList"/>
    </card-body>
  </card-block>
</template>

<script>

export default {
  data: function () {
    return {
      data: null,
      progress: true,
      filter: {
        active: 'all',
        search: '',
      }
    }
  },
  props: {},
  computed: {},
  beforeMount() {
    this.filter = storageLoad('filter_' + this.$route.name, this.filter);
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {

      let v = _.clone(this.filter);
      v.search = '';
      storageSet('filter_' + this.$route.name, v);

      axiosGetValue('/api/admin/subscription-tariff/list', {
            page: this.$refs.paginate.currentPage,
            per_page: this.$refs.paginate.perPage,
            filter: this.filter,
          },
          e => this.data = e, e => this.progress = e
      )
    }
  }
}
</script>